import React from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import styles from './ManageOrderFilterTabs.module.scss';

const ManageOrderFilterTabs = ({ activeTab, setActiveTab }) => {
    return (
        <>
            <Nav className={styles.filterTabs}>
                <NavItem className={styles.navItem}>
                    <NavLink
                        className={`${styles.navLink} ${activeTab === 'all' ? styles.activeTab : ''}`}
                        onClick={() => setActiveTab('all')}
                    >
                        All
                    </NavLink>
                </NavItem>
                <NavItem className={styles.navItem}>
                    <NavLink
                        className={`${styles.navLink} ${activeTab === 'pending' ? styles.activeTab : ''}`}
                        onClick={() => setActiveTab('pending')}
                    >
                        Pending
                    </NavLink>
                </NavItem>
                <NavItem className={styles.navItem}>
                    <NavLink
                        className={`${styles.navLink} ${activeTab === 'readyToShip' ? styles.activeTab : ''}`}
                        onClick={() => setActiveTab('readyToShip')}
                    >
                        Ready to ship
                    </NavLink>
                </NavItem>
                <NavItem className={styles.navItem}>
                    <NavLink
                        className={`${styles.navLink} ${activeTab === 'shipped' ? styles.activeTab : ''}`}
                        onClick={() => setActiveTab('shipped')}
                    >
                        Shipped
                    </NavLink>
                </NavItem>
                <NavItem className={styles.navItem}>
                    <NavLink
                        className={`${styles.navLink} ${activeTab === 'delivered' ? styles.activeTab : ''}`}
                        onClick={() => setActiveTab('delivered')}
                    >
                        Delivered
                    </NavLink>
                </NavItem>
                <NavItem className={styles.navItem}>
                    <NavLink
                        className={`${styles.navLink} ${activeTab === 'cancelled' ? styles.activeTab : ''}`}
                        onClick={() => setActiveTab('cancelled')}
                    >
                        Cancelled
                    </NavLink>
                </NavItem>
                <NavItem className={styles.navItem}>
                    <NavLink
                        className={`${styles.navLink} ${activeTab === 'returned' ? styles.activeTab : ''}`}
                        onClick={() => setActiveTab('returned')}
                    >
                        Returned
                    </NavLink>
                </NavItem>
                <NavItem className={styles.navItem}>
                    <NavLink
                        className={`${styles.navLink} ${activeTab === 'refundOnly' ? styles.activeTab : ''}`}
                        onClick={() => setActiveTab('refundOnly')}
                    >
                        Refund only
                    </NavLink>
                </NavItem>
                <NavItem className={styles.navItem}>
                    <NavLink
                        className={`${styles.navLink} ${activeTab === 'failedDelivery' ? styles.activeTab : ''}`}
                        onClick={() => setActiveTab('failedDelivery')}
                    >
                        Failed Delivery
                    </NavLink>
                </NavItem>
            </Nav>
        </>
    );
};

export default ManageOrderFilterTabs;